export const fields = ["a software engineer", "a knowledge seeker", "a believer in God"];
